<template>
  <div class="contactus-list-wrap">
    <template-search-read-list
      :listApi="listApi"
      :buttonOption="buttonOption"
      :defaultSortBy="defaultSortBy"
      :reload="reload"
      :initialSearchFilter="initialSearchFilter"
      :selected="selected"
      :heightOffset="310"
      :menu="'docent'"
      @select="setSelected"
      @button="button"
      @showDetail="showDetail"
    >
    </template-search-read-list>
    <template-detail
      :infoApi="infoApi"
      :editApi="editApi"
      :apiParam="apiParam"
      :service="'contactUsHistory'"
      @reload="reloadList"
      @close="setSelected"
      @button="detailButton"
    >
    </template-detail>
  </div>
</template>

<script>
import {
  getContactUsHistoryDetail,
  getContactUsHistoryList,
  updateContactusHistory,
} from "@/api/contact";
import TemplateDetail from "@/components/_template/Detail";
import TemplateSearchReadList from "@/components/_template/SearchReadList.vue";
import UiButton from "@/components/_ui/UiButton";
import { EventBus } from "@/utils/event-bus";
import {alertError, SOLOMON_URL} from "@/utils/tools";
import {
  getDocentHistoryDetail,
  getDocentHistoryList,
  getGeoDocentHistoryDetail,
  getGeoDocentHistoryList,
  updateDocentHistory, updateGeoDocentHistory
} from '@/api/docent'

export default {
  name: "DocentHistoryList",
  components: {
    TemplateSearchReadList,
    TemplateDetail,
    UiButton,
  },
  methods: {
    showDetail(data) {
      this.apiParam = { id: data.sessionKey };
    },
    reloadList () {
      this.reload++
    },
    detailButton(value, data) {
      window.open(`${SOLOMON_URL}/report/${data.aid}`)
    },
    button(value, data) {
      if (value === "save") {
        EventBus.$emit("onLoading", true);
        updateContactusHistory({
          id: data.sessionKey,
          adminMemo: data.adminMemo,
        })
          .then((response) => {
            alert("메모가 저장되었습니다.");
            this.reload++;
          })
          .catch((error) => {
            alertError("저장에 실패했습니다.", error);
          })
          .finally(() => {
            EventBus.$emit("onLoading", false);
          });
      }
    },
    setSelected(row) {
      this.selected = row;
    },
  },
  data() {
    return {
      reload: 0,
      selected: null,

      apiParam: null,
      infoApi: getGeoDocentHistoryDetail,
      editApi: updateGeoDocentHistory,
      listApi: getGeoDocentHistoryList,
      buttonOption: [
        {
          action: "showDetail",
          columnText: "자세히",
          buttonText: '<i class="xi-arrow-right"></i>',
        },
      ],
      defaultSortBy: "",
      initialSearchFilter: null,
    };
  },
};
</script>

<style lang="scss" scoped>
.contactus-list-wrap {
}
</style>
